import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=80356b3e&scoped=true&"
import script from "./DropArea.vue?vue&type=script&lang=ts&"
export * from "./DropArea.vue?vue&type=script&lang=ts&"
import style0 from "./DropArea.vue?vue&type=style&index=0&id=80356b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80356b3e",
  null
  
)

export default component.exports